export default {
  storeTicker(state, payload) {
    const newPayload = Object.assign(state.tickers, payload);
    state.tickers = newPayload; // eslint-disable-line no-param-reassign
    return state;
  },
  storeRadioValue(state, payload) {
    state.radioValues = payload; // eslint-disable-line no-param-reassign
    return state;
  },
};
